import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MemberOnboardingDetailsService {
  private _memberOnboardingDetailsSubmitted = new Subject<void>();
  public memberOnboardingDetailsSubmitted$ = this._memberOnboardingDetailsSubmitted as Observable<void>;
  public setMemberOnboardingDetailsSubmitted(): void {
    this._memberOnboardingDetailsSubmitted.next();
  }
}
